/**
 * A Thrive search's status as a pill: Open is live work (green), Business
 * Development a prospect (accent), anything else (Closed, Lost) is history and
 * reads muted. Moved from `SearchDetailPage.tsx` (epic
 * 2026-10-15-thrive-search-import, sub-task 03) so the New Import wizard's
 * search picker draws the same pill.
 */
export function searchStatusClasses(status: string | null | undefined): string {
  const base = "inline-block rounded-full px-2 py-0.5 text-label";
  if (status === "Open") return `${base} bg-success-muted text-success`;
  if (status === "Business Development") return `${base} bg-accent-muted text-accent-ink`;
  return `${base} bg-surface-raised text-text-muted`;
}
